import React from 'react'
import {useMediaQuery} from '@mui/material'
import {useSelector} from 'react-redux'
import BoxAtom from '../../../@atoms/to_layout/box/box.atom'
import ProgressBarAtom from '../../../@atoms/to_forms/progressbar/progressbar.atom'
import {VisitActionProps, VisitProps} from '../card_visit_details.component'
import {VisitActionWithInstructions} from './card_visit_header.component'
import {RootState} from '../../../store_redux'

const OrderStatusComponent: React.FC<
  Pick<VisitActionProps, 'expanded'> & VisitProps
> = function ({visit, expanded}) {
  const labels = useSelector((state: RootState) => state.labels)
  const matches = useMediaQuery('(max-width:480px)')
  const {progressStatusCode, isShipmentFailed} = visit
  const visitStatusKey = isShipmentFailed ? 'failedVisitStatus' : 'visitStatus'
  const progressStages = {
    delivery: labels.myOrders[visitStatusKey].delivery,
    collection: labels.myOrders[visitStatusKey].collection,
    exchange: labels.myOrders[visitStatusKey].exchange,
  }
  const progressLabels =
    progressStages[
      visit.visitType?.toLowerCase() as keyof typeof progressStages
    ]
  return (
    <BoxAtom
      className={matches ? 'mobile progressbar-wrapper' : 'progressbar-wrapper'}
    >
      <ProgressBarAtom
        ap_progress_status_arr={progressLabels}
        ap_progress_step={progressStatusCode}
        ap_is_step_failed={isShipmentFailed}
      />
      {matches && (
        <VisitActionWithInstructions visit={visit} expanded={expanded} />
      )}
    </BoxAtom>
  )
}

export default OrderStatusComponent
